import { render, staticRenderFns } from "./StatusComitente.vue?vue&type=template&id=2fe63662&"
import script from "./StatusComitente.vue?vue&type=script&lang=js&"
export * from "./StatusComitente.vue?vue&type=script&lang=js&"
import style0 from "./StatusComitente.vue?vue&type=style&index=0&id=2fe63662&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports